import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterPropCcraPerUsage',
  standalone: false,
})
export class FilterPropCcraPerUsagePipe implements PipeTransform {
  transform(ccras: Record<string, any>[], currentUsage: string): Record<string, any>[] {
    if (
      currentUsage != null &&
      Array.isArray(ccras) &&
      ccras.length > 0 &&
      ccras.every(company => 'ref_property_usage_type_desc' in company)
    ) {
      return ccras.filter(ccra => ccra.ref_property_usage_type_desc === currentUsage);
    }
    return ccras;
  }
}
